import React from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";

import mock from "./mock";

import MovieAlbum from "../MovieAlbum";

import { useHomeInfo } from "../../useGlobal";

const useStyles = makeStyles(theme =>
  createStyles({
    album: {
      marginBottom: theme.spacing(5),
    },
  }),
);

export default function MovieContainer (props) {
  const classes = useStyles();
  const { slots } = useHomeInfo();

  return (
    <div>
      {slots.map(slot => {
        return (
          <div className={classes.album} key={`slot-${slot.id}`}>
            <MovieAlbum
              slot={slot}
              hideTitleIcon={true}
              hoverEnlargePoster={true}
            ></MovieAlbum>
          </div>
        );
      })}
    </div>
  );
}
